import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useStepperControl } from "@/hooks/useStepperControl";
import { useEffect, useMemo } from "react";
import { Tax } from "../tax";
import { UserData } from "../userdata";
import { Breadcrumbs } from "@/components/common/Breadcrumbs";
import { DadosProcesso } from "../dados-processos";
var BREADCRUMB_ITEMS = [
    {
        name: "Página Inicial",
        path: "/",
    },
    {
        name: process.env.BREADCRUMB_ITEM_NAME,
        path: process.env.BREADCRUMB_ITEM_PATH,
    },
];
export function Home() {
    var _a = useStepperControl(), activeStep = _a.activeStep, moveThroughStep = _a.moveThroughStep;
    var steps = useMemo(function () {
        return [
            {
                title: "Cadastro",
                component: UserData,
            },
            {
                title: "Dados do Processo",
                component: DadosProcesso,
            },
            {
                title: "Cadastro",
                component: Tax,
            },
        ];
    }, []);
    useEffect(function () {
        if (!activeStep || activeStep > steps.length - 1) {
            moveThroughStep(0);
        }
    }, [activeStep]);
    if (typeof activeStep === "boolean") {
        return _jsx(_Fragment, {});
    }
    var Step = steps[activeStep].component;
    return (_jsxs(_Fragment, { children: [_jsx(Breadcrumbs, { pages: BREADCRUMB_ITEMS }), _jsx(Step, {})] }));
}
